import React, { useState } from 'react';
import { getCookieConsent, setCookieConsent } from '../utils/cookieConsent';
import './CookieConsentBanner.css';

const CookieConsentBanner = () => {
    const [visible, setVisible] = useState(() => !getCookieConsent());

    if (!visible) return null;

    const handleAccept = () => {
        setCookieConsent();
        setVisible(false);
    };

    return (
        <div className="cookie-consent">
            <p className="cookie-consent__text">
                Мы используем файлы cookie для работы сайта и аналитики. Продолжая пользоваться Dealzy, вы соглашаетесь с их использованием.
            </p>
            <button className="cookie-consent__btn" onClick={handleAccept}>Понятно</button>
        </div>
    );
};

export default CookieConsentBanner;
